(ns practitest.frontend.history-tab
  (:require
    [practitest.frontend.events :as events]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]
    [practitest.frontend.init :as init]
    [practitest.frontend.components.history :as history]
    [practitest.frontend.common.utils :as utils]))

(defn history-tab-data [_]
  (let [entity-key @(re-frame/subscribe [::subs/current-entity-key])]
    [history/history entity-key]))

(defn ^:dev/after-load mount-root []
  (init/remount-roots "history-tab-component"
                      history-tab-data))

(defn ^:export init [webcomponent options]
  (init/init! {:options       options
               :init-event-fn (fn [config]
                                (let [entity-type (keyword (:entity-key config))]
                                  [::events/initialize-db config entity-type
                                   ;; Fetch data
                                   [[::events/fetch-history-by-uri entity-type (:history-uri config)]]]))
               :webcomponent  webcomponent
               :root-view     history-tab-data}))

(utils/register-webcomponent! "history-tab-component")
